import sliceCreator from '../../index.jsx';
import {UPDATE_REGION} from '../../../constants/index.jsx';
const _updateRegionAction = sliceCreator('UPDATE_REGION', UPDATE_REGION, 'put');

const { asyncAction: updateRegionAction, reducer, clearData: clearUpdateRegionAction } = _updateRegionAction;

export default reducer;

export {
    updateRegionAction,
    clearUpdateRegionAction
}